/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model(props) {
  const { nodes, materials } = useGLTF('./libs/bulb.glb')
  return (
    <group {...props} dispose={null} scale={0.5}>
      <group scale={0.03}>
        <primitive object={nodes.pm0001_00} />
        <skinnedMesh
          name="Bulbasaur_1"
          geometry={nodes.Bulbasaur_1.geometry}
          material={materials.Skin}
          skeleton={nodes.Bulbasaur_1.skeleton}
          morphTargetDictionary={nodes.Bulbasaur_1.morphTargetDictionary}
          morphTargetInfluences={nodes.Bulbasaur_1.morphTargetInfluences}
        />
        <skinnedMesh
          name="Bulbasaur_2"
          geometry={nodes.Bulbasaur_2.geometry}
          material={materials.Eyelid}
          skeleton={nodes.Bulbasaur_2.skeleton}
          morphTargetDictionary={nodes.Bulbasaur_2.morphTargetDictionary}
          morphTargetInfluences={nodes.Bulbasaur_2.morphTargetInfluences}
        />
        <skinnedMesh
          name="Bulbasaur_3"
          geometry={nodes.Bulbasaur_3.geometry}
          material={materials.Leaf}
          skeleton={nodes.Bulbasaur_3.skeleton}
          morphTargetDictionary={nodes.Bulbasaur_3.morphTargetDictionary}
          morphTargetInfluences={nodes.Bulbasaur_3.morphTargetInfluences}
        />
        <skinnedMesh
          name="Bulbasaur_4"
          geometry={nodes.Bulbasaur_4.geometry}
          material={materials.IrisL}
          skeleton={nodes.Bulbasaur_4.skeleton}
          morphTargetDictionary={nodes.Bulbasaur_4.morphTargetDictionary}
          morphTargetInfluences={nodes.Bulbasaur_4.morphTargetInfluences}
        />
        <skinnedMesh
          name="Bulbasaur_5"
          geometry={nodes.Bulbasaur_5.geometry}
          material={materials.IrisR}
          skeleton={nodes.Bulbasaur_5.skeleton}
          morphTargetDictionary={nodes.Bulbasaur_5.morphTargetDictionary}
          morphTargetInfluences={nodes.Bulbasaur_5.morphTargetInfluences}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/bulb.glb')
